/*
    * Used to access data from the state tree of the store
*/
import { GetterTree } from "vuex";
import { RootState } from "../../types";
import { App } from "./types";

export const getters: GetterTree<App, RootState> = {
    /*
        * Triggered button signOut event
    */
    _appSignOutComponent(state) {
        //#.Remove profile components in the DOM
        state.profile = false;
    },

    _appUser(state) {
        return state.loggedInUser;
    },

    _appUserId(state) {
        return state.userId;
    }
};
